export const containerStyles = `
   flex flex-col items-center gap-6 
   w-full
`

export const headerStyles = 'flex flex-col items-center gap-4'

export const headerTextContainerStyles =
   'flex flex-col items-center text-center gap-1'

export const descriptionStyles = 'flex flex-col gap-[4px] items-center'

export const otpSectionStyles = 'flex flex-col gap-[4px]'

export const headerTextStyles = `
   text-lg-semibold
`

export const labelTextStyles = `
   text-sm-regular
`

export const otpValueStyles = `
   text-sm-semibold
`
